"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _core = require("@material-ui/core");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "isTabSelected", "isWebinars", "index"];
var __jsx = _react.default.createElement;
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    tabPanelVisible: {
      display: 'block'
    }
  };
});
var TabPanel = function TabPanel(props) {
  var classes = useStyles();
  var children = props.children,
    isTabSelected = props.isTabSelected,
    _props$isWebinars = props.isWebinars,
    isWebinars = _props$isWebinars === void 0 ? false : _props$isWebinars,
    index = props.index,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  return __jsx("div", (0, _extends2.default)({
    role: "tabpanel",
    hidden: !isTabSelected,
    id: "tabpanel-".concat(index),
    className: (0, _clsx2.default)("cmp-tabs__tabpanel", (0, _defineProperty2.default)({}, classes.tabPanelVisible, isWebinars && isTabSelected)),
    "data-cmp-hook-tabs": "tabpanel",
    "aria-labelledby": "tab-".concat(index)
  }, rest), children);
};
var _default = TabPanel;
exports.default = _default;